import { render, staticRenderFns } from "./questionnairetaskmain.vue?vue&type=template&id=415b48c2&"
import script from "./questionnairetaskmain.vue?vue&type=script&lang=js&"
export * from "./questionnairetaskmain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports